import React from 'react';
import { Grid, List, ListItem, ListItemText, Divider, Button, Slide, Fab } from '@material-ui/core';
import PropTypes from 'prop-types';
import Utils from '../../providers/Utils';
import styled, { keyframes, css } from 'styled-components'
import { flash, zoomOut, rubberBand } from 'react-animations'
import { setTimeout } from 'timers';
import DialogSubIntrebare from './DialogSubIntrebare';
import WsC from './providers/WsC'
import { ReactComponent as CheckCircle } from './Icoane Font Awesome/check-circle-regular.svg';

const flashS = keyframes`
    ${flash}
`;

const headS = keyframes`
    ${rubberBand}
`;

const zoomO = keyframes`
    ${zoomOut}
`;

const animateZoom = props => css`${zoomO} 0.5s`;

const animate = props => css`${flashS} ${props.animationLength}`;

const headA = props => css`${headS} 1s`;

const HeadShake = styled.div`animation:${props => props.Active ? headA : ''}`;



// const FadeOutLeft = styled.div`animation: 3s ${keyframes`${fadeOutLeft}`}`;
// const FadeOutRight = styled.div`animation: 3s ${keyframes`${fadeOutRight}`}`;

const Flash = styled.span`animation:${props => props.Active ? animate : ''}`;
const Zoom = styled.div`animation:${props => props.Active ? animateZoom : ''}`;

export default class ListaIntrebariChestionareTemplate extends React.Component {
    constructor(props) {
        super(props);
        this.raspunsuriInsert = React.createRef();
        this.state = {
            raspunsuri: [],
            intrebareToAnimate: null,
            intrebariChildren: []

        }
    }

    componentDidMount() {
        this.getRaspunsuri()
    }

    schimbaPozitie = (v, n) => {

        //   console.log('SchimbaPozitie :');
        let newList = this.props.listaIntrebari.map((el, k) => {
            switch (k) {
                case v: return this.props.listaIntrebari[n];
                case n: return this.props.listaIntrebari[v];
                default: return el;
            }
        })

        this.props.pozitieNoua(newList)


    }







    getRaspunsuri = async (idIntrebare = null) => {

        // console.log('tempGets Here :', this.props.isIntrebariTemplate);



        let ws = new WsC();


        let getRaspunsuri;
        let getIntrebariChildren;

        let idIntrebari = new Set(this.props.listaIntrebari.map(i => i.id))
        idIntrebari = [...idIntrebari]

        //  console.log('idIntrebari iduri intrebari:', idIntrebari);




        if (idIntrebari.length > 0) {


            if (this.props.isIntrebariTemplate !== true) {



                getRaspunsuri = ws.customSelect(`select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc `, {
                    p1: '1'
                })
            }
            else {
                getRaspunsuri = ws.customSelect('select * from template_chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc', {
                    p1: '1'
                })
            }


            if (this.props.isIntrebariTemplate !== true) {

                getIntrebariChildren = ws.customSelect(`select * from chestionare_intrebari where id_parent in (${idIntrebari}) and isnull(inactiv,0) != 1 order by isnull(ordinea,0) asc, id`, {
                   p1: '1'
               })
           } else {
                getIntrebariChildren = ws.customSelect(`select * from template_chestionare_intrebari where id_parent in (${idIntrebari}) and isnull(inactiv,0) != 1 order by isnull(ordinea,0) asc, id`, {
                   p1: '1'
               })
           }


            let [r, iC] = await Promise.all([getRaspunsuri, getIntrebariChildren])

            //    console.warn('raspunsuri', r)
            //   console.warn('intrebari children', iC)

            if (r.Succes && iC.Succes) {


                //      console.warn('iC :', iC);

                let raspunsuri = [...r.Content]

                //   console.log('raspunsuri :', raspunsuri);


                for (let i = 0, n = raspunsuri.length; i < n; i++) {
                    raspunsuri[i].active = false
                }



                //   console.warn('this.props.listaIntrebari :', this.props.listaIntrebari);
                for (let i = 0, n = iC.Content.length; i < n; i++) {


                    let raspunsuriFilter = raspunsuri.filter(rasp => rasp.id_intrebare === iC.Content[i].id).map((m, idx) => {



                        return m.label
                    }).join(' - ')

                    raspunsuri.push({
                        id: iC.Content[i].id,
                        idx: i + 1,
                        id_intrebare_grupaj: iC.Content[i].id,
                        id_intrebare: iC.Content[i].id_parent,
                        id_grupaj: iC.Content[i].id_grupaj,
                        label: raspunsuriFilter,
                        label_rapoarte: null,
                        inactiv: 0,
                        img_src: null,
                        motivatie_raspuns: null
                    })


                }

                let cloneSubintrebari = [...iC.Content]

                for (let i = 0, n = cloneSubintrebari.length; i < n; i++) {
                    //  console.warn('enter looop')
                    let raspunsuriClone = raspunsuri.filter(r => r.id_intrebare === cloneSubintrebari[i].id)
                    //    console.warn('raspunsuri clone =-====', raspunsuriClone)
                    cloneSubintrebari[i].raspunsuri = raspunsuriClone
                }

                //  console.warn('raspunsuri :', raspunsuri);

                // console.log('r :', r);
                //         if(r.Succes && rTemp.Succes){

                //             let cloneRaspunsuri = [...r.Content]

                //             let counter = rTemp.Content.length


                //             for(let i = 0 ; i< counter; i++){
                //                 cloneRaspunsuri.push(rTemp.Content[i])

                //             }



                this.setState({
                    raspunsuri: raspunsuri,
                    intrebariChildren: cloneSubintrebari,
                    intrebareToAnimate: idIntrebare
                }, () => {
                    console.warn('this.state.objIntrebareInfo.id:', this.state.intrebareToAnimate)
                })

            }





        } else {

            //  console.warn('templates')
            if (this.props.isIntrebariTemplate !== true) {



                getRaspunsuri = await ws.customSelect(`select * from chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc`, {
                    p1: '1'
                })
            }
            else {
                getRaspunsuri = await ws.customSelect('select * from template_chestionare_intrebari_optiuni_raspuns where isnull(inactiv,0) != 1 order by id asc', {
                    p1: '1'
                })
            }

            //  console.warn('getRaspunsuri :', getRaspunsuri);



            if (getRaspunsuri.Succes) {




                let raspunsuri = [...getRaspunsuri.Content]

                //   console.log('raspunsuri :', raspunsuri);


                for (let i = 0, n = raspunsuri.length; i < n; i++) {
                    raspunsuri[i].active = false
                }


                //  console.warn('raspunsuri :', raspunsuri);


                this.setState({
                    raspunsuri: raspunsuri,
                    intrebariChildren: [],
                    intrebareToAnimate: idIntrebare
                }, () => {

                })

            }

        }





    }




    changeRaspuns = (ev, r) => {
        let raspunsuri = [...this.state.raspunsuri]

        let idx = raspunsuri.findIndex(c => c.id === r.id)

        if (idx !== -1) {
            raspunsuri[idx].label = ev.target.value
        }

        this.setState({ raspunsuri: raspunsuri })

    }

    deleteRaspuns = async (r) => {
        //  console.log('r :', r);

        // let raspunsToAnimate = document.getElementById(`animateraspuns${r.id}`)

        let raspunsuri = [...this.state.raspunsuri]


        let idx = raspunsuri.findIndex(c => c.id === r.id)

        if (idx !== -1) {
            raspunsuri[idx].active = true
        }

        this.setState({ raspunsuri: raspunsuri }, async () => {
            setTimeout(async () => {
                let ws = new WsC();


                let updateRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', { inactiv: 1 }, { id: r.id })

                if (updateRaspuns.Succes) {
                    //    console.log('succesUpdate :', updateRaspuns);
                    this.getRaspunsuri()
                }
            }, 1000)

        })

        // console.log('raspunsToAnimate :', raspunsToAnimate);





    }
    render() {
        return (
            <div>
                <Grid container  >



                    <div style={{ width: '100%', display: 'flex', flex: 1, justifyContent: 'space-between' }}>
                        <Button style={{ display: this.props.goBack === true ? 'inline-flex' : 'none' }} className='chestionare-appbar-buttons' onClick={this.props.goBackFunc} >
                            <i style={{ verticalAlign: 'bottom' }} className='material-icons'>keyboard_arrow_left</i>
                            <span className='chestionare-appbar-button-text'>Inapoi</span>
                        </Button>

                        <Button style={{ display: this.props.goBack === true ? 'inline-flex' : 'none' }} className='chestionare-appbar-buttons' onClick={this.props.importaChestionar} >
                            <i style={{ verticalAlign: 'bottom' }} className='material-icons'>keyboard_arrow_right</i>
                            <span className='chestionare-appbar-button-text'>Foloseste Chestionarul</span>
                        </Button>

                    </div>


                    <Grid item xs={12} sm={12} md={12} l={12} xl={12} className='chestionare-container-item'>



                        <List className="chestionare-common-list" >
                            {
                                this.props.listaIntrebari.filter(i=>i.id_parent === null).map((i, idx) => {
                                    return (

                                        <LiListaIntrebari displayFab={this.props.displayFab}
                                            preview={this.props.preview}
                                            left={this.props.left}
                                            key={'intrebare' + idx}
                                            intrebare={i}
                                            idx={idx}
                                            intrebariChildren={this.state.intrebariChildren.filter(int => int.id_parent === i.id)}
                                            openEdit={this.props.openEdit}
                                            count={this.props.listaIntrebari.length}
                                            mutaSus={this.mutaSus}
                                            mutaJos={this.mutaJos}
                                            onClick={this.props.goToIntrebare}
                                            isTemplate={this.props.isTemplate}
                                            raspunsuri={this.state.raspunsuri}
                                            dragStart={this.props.dragStart}
                                            moveToList={this.props.moveToList}
                                            deleteIntrebare={this.props.deleteIntrebare}
                                            changeIntrebare={this.props.changeIntrebare}
                                            changeRaspuns={this.changeRaspuns}
                                            getRaspunsuri={this.getRaspunsuri}
                                            deleteRaspuns={this.deleteRaspuns}
                                            intrebareToAnimate={this.state.intrebareToAnimate}

                                        />
                                    )
                                })
                            }
                        </List>

                    </Grid>
                </Grid>
            </div>
        );
    }
}


class LiListaIntrebari extends React.Component {
    constructor(props) {
        super(props);
        this.subIntrebare = React.createRef()
        this.textInput = React.createRef();
        this.state = {
            raspunsuri: [],
            isDrag: false,
            hideText: true,
            raspunsNou: 'Adauga Raspuns',
            fade: false,
            flashOn: false,
            zoomActive: false,
            isOpenSubintrebare: false,
            objIntrebareChild: { tip: '' }
        }

    }



    componentDidMount() {

    }

    focus = () => {
        this.setState({ hideText: false }, () => {
            this.textInput.current.focus()

        })


    }

    getInputRaspuns = (r, rasp, i = null) => {

        //   console.log('this.props.intrebare :', this.props.intrebare);

        if (this.props.intrebare.tip === 'grupaj') {
            //   console.log('grupaj :');

            //  console.log('raspuns :', rasp);

            let intrebareToAdd = {
                idx: rasp.idx,
                id: rasp.id_intrebare_grupaj,
                intrebare: this.props.intrebare.intrebare,
                id_parent: rasp.id_intrebare,
                id_grupaj: rasp.id_grupaj,
                id_categorie: 1,
                tip: 'radio'
            }

            //   console.log('intrebareToAdd :', intrebareToAdd);

            this.setState({
                isOpenSubintrebare: true,
                objIntrebareChild: intrebareToAdd
            }, () => {
                this.subIntrebare.current.getRaspunsuri()
            })

        }
        else if (this.props.intrebare.tip === 'subintrebare') {
            //   console.log('enterSubraspuns :');
            //   console.log('r :', r);
            //   console.log('rasp :', rasp);

            let intrebareToAdd = {
                idx: rasp.idx,
                id: rasp.id_intrebare_grupaj,
                intrebare: i.intrebare,
                id_parent: rasp.id_intrebare,
                id_grupaj: rasp.id_grupaj,
                motivatie_label: i.motivatie_label,
                id_categorie: 1,
                tip: i.tip
            }
            this.setState({
                isOpenSubintrebare: true,
                objIntrebareChild: intrebareToAdd
            }, () => {
                this.subIntrebare.current.getRaspunsuri()
            })
        }
        // else {

            //   console.log('r :', r);
            // let input = document.getElementById(r).focus();
        // }




    }

    deleteRaspuns = async (r) => {
        //  console.log('r :', r);

        let ws = new WsC()

        let deleteRaspuns = await ws.update('chestionare_intrebari', { inactiv: 1 }, { id: r.id_intrebare_grupaj })

        if (deleteRaspuns.Succes) {
            this.props.getRaspunsuri()
        }
    }

    deleteSubintrebare = async (r) => {

        let ws = new WsC()
        //   console.warn('subintrebare :', r);
        let deleteRaspuns = await ws.update('chestionare_intrebari', { inactiv: 1 }, { id: r.id })

        if (deleteRaspuns.Succes) {
            this.props.getRaspunsuri()
        }
    }

    updateRaspuns = async (r) => {
        // console.log('r :', r);

        let ws = new WsC();

        let updateRaspuns = await ws.update('chestionare_intrebari_optiuni_raspuns', { label: r.label }, { id: r.id })

        if (updateRaspuns.Succes) {
            //   console.log('succesUpdate :', updateRaspuns);
        }
    }



    insertRaspuns = async () => {
        // console.log('raspuns nou :', this.state.raspunsNou);

        let ws = new WsC();

        if (this.props.intrebare.tip !== 'grupaj') {
            if (this.props.intrebare.tip === 'subintrebare') {


                // let intrebare = this.props.intrebare
                let u = new Utils()

                let intrebareToAdd = {
                    id_chestionar: this.props.intrebare.id_chestionar,
                    intrebare: this.props.nume,
                    id_parent: this.props.intrebare.id,
                    id_grupaj: u.generateId(),
                    id_categorie: 1,
                    tip: 'radio',
                }
                //   console.log('intrebare Parent:', intrebare);
                //  console.log('intrebareToAdd :', intrebareToAdd);

                let insert = await ws.insert('chestionare_intrebari', intrebareToAdd)

                //   console.log('insert :', insert);

                if (insert.Succes) {

                    intrebareToAdd.id = insert.Content[0].id



                    this.setState({
                        isOpenSubintrebare: true,
                        objIntrebareChild: intrebareToAdd
                    }, () => {
                        this.props.getRaspunsuri()
                    })
                }



            } else {
                let insert = await ws.insert('chestionare_intrebari_optiuni_raspuns', {
                    id_intrebare: this.props.intrebare.id,
                    label: this.state.raspunsNou,
                    tip: this.props.intrebare.tip
                })

                //  console.warn('insert :', insert);
                if (insert.Succes) {
                    if (!this.props.intrebare.tip.includes('img')) {
                        this.setState({ raspunsNou: 'Adauga raspuns' }, () => {
                            this.props.getRaspunsuri()

                        })
                    } else {

                        await this.props.getRaspunsuri()
                        this.selectFile(`file-poza-raspuns${insert.Content[0].id}`)
                    }


                }
            }


        } else {
            let intrebare = this.props.intrebare
            let u = new Utils()

            let intrebareToAdd = {
                intrebare: intrebare.intrebare,
                id_parent: intrebare.id,
                id_grupaj: u.generateId(),
                id_categorie: 1,
                tip: 'radio',
            }
            // console.log('intrebare Parent:', intrebare);
            // console.log('intrebareToAdd :', intrebareToAdd);

            let insert = await ws.insert('chestionare_intrebari', intrebareToAdd)

            // console.log('insert :', insert);

            if (insert.Succes) {

                intrebareToAdd.id = insert.Content[0].id

                this.setState({
                    isOpenSubintrebare: true,
                    objIntrebareChild: intrebareToAdd,

                }, () => {
                    this.props.getRaspunsuri()

                })
            }
        }


    }

    selectFile = (id) => {

        //  console.log('Incepe poza');

        // console.log('id :', id);
        let pi = document.getElementById(id);

        //  console.log('pi :', pi);

        pi.click()

    }

    uploadPoza = async (id, idRaspuns) => {


        let ws = new WsC();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);


        //  console.log('idRaspuns :', idRaspuns);



        reader.onload = async () => {
            // let fileContent = reader.result;
            //   console.log(fileContent);
            //  console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/UpdatePozaRaspuns/?idRaspuns', saveFile, idRaspuns);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {


                this.props.getRaspunsuri()

            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);


        }
    }



    filterRaspunsuri = () => {
        let cloneRaspunsuri = [...this.props.raspunsuri]

        let varianteRaspuns = cloneRaspunsuri.filter(r => r.id_intrebare === this.props.intrebare.id)

        // console.log('varianteRaspuns :', varianteRaspuns);

        if (this.props.intrebare.tip.includes('img')) {
            return varianteRaspuns.map((r, idx) => {
                if (r.img_src !== null) {
                    return (

                        <span style={{ marginLeft: 10, display: 'block', position: 'relative', width: '85%', marginBottom: 10 }} key={'raspuns' + idx}>

                            <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}> {new Utils().alfabet[idx]})
                        <img alt={r.img_src} style={{ maxWidth: 50 }} src={new WsC().adresaMedia + `/Chestionare/Raspunsuri_img/${r.img_src}`} />
                                <input type='file' id={`file-poza-raspuns${r.id}`}
                                    style={{ display: 'none' }}
                                    accept='image/*'
                                    onChange={() => { this.uploadPoza(`file-poza-raspuns${r.id}`, r.id) }}
                                />

                                {!this.props.isTemplate &&
                                    <span style={{ position: 'absolute', top: 0, right: -50 }}>
                                        <i style={{ marginRight: 5, color: 'rgb(34,159,136)', fontSize: 20 }} onClick={() => { this.selectFile(`file-poza-raspuns${r.id}`) }} className="material-icons chestionare-list-intrebari-icons">edit</i>
                                        <i onClick={() => { this.props.deleteRaspuns(r) }} style={{ marginRight: 0, color: 'rgb(244,20,41)', fontSize: 20 }} className="material-icons chestionare-list-intrebari-icons">clear</i>
                                    </span>
                                }

                            </Flash>
                        </span>
                    )
                } else {
                    return (

                        <span style={{ marginLeft: 10, display: 'block', position: 'relative', width: '85%', marginBottom: 10 }} key={'raspuns' + idx}>
                            <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}>
                                 {new Utils().alfabet[idx]})   <i className='material-icons'>image</i>
                                <input type='file' id={`file-poza-raspuns${r.id}`}
                                    style={{ display: 'none' }}
                                    accept='image/*'
                                    onChange={() => { this.uploadPoza(`file-poza-raspuns${r.id}`, r.id) }}
                                />
                                {!this.props.isTemplate &&
                                    <span style={{ position: 'absolute', top: 0, right: -50 }}>
                                        <i style={{ marginRight: 5, color: 'rgb(34,159,136)', fontSize: 20 }} onClick={() => { this.selectFile(`file-poza-raspuns${r.id}`) }} className="material-icons chestionare-list-intrebari-icons">edit</i>
                                        <i onClick={() => { this.props.deleteRaspuns(r) }} style={{ marginRight: 0, color: 'rgb(244,20,41)', fontSize: 20 }} className="material-icons chestionare-list-intrebari-icons">clear</i>
                                    </span>
                                }
                            </Flash>
                        </span>
                    )

                }
            })

        }
        else if (this.props.intrebare.tip === 'subintrebare') {
            return this.props.intrebariChildren.map((ic, idx2) => {
                return (
                    <span style={{ position: 'relative', display: 'block' }} key={`intrebarechild${idx2}`}>
                        <span style={{ display: 'block' }} >{this.props.idx + 1}.{idx2 + 1}. {ic.intrebare} </span>
                        {ic.raspunsuri.map((r, idx) => {
                            return (
                                <span style={{ marginLeft: 5, position: 'relative', width: '100%', marginBottom: 10, }} key={'raspuns' + idx} >
                                    <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}> {new Utils().alfabet[idx]}) 
                                        {/* <span style={{display:this.state.hideText ? 'inline-block' : 'none', wordBreak:'break-all', width:'90%'}} >{r.label}</span>    */}

                                        <span style={{
                                            color: 'rgb(91, 136, 134)',
                                            fontSize: 15,
                                        }}>
                                            {r.label}   {ic.tip.indexOf('motivatie') !== -1 &&
                                                <span
                                                    style={{ marginLeft: 5, }}
                                                ><span style={{ color: 'rgb(91, 136, 134)' }}> {ic.motivatie_label}</span></span>
                                            }
                                        </span> <br />




                                    </Flash>
                                </span>
                            )
                        })}



                        {!this.props.isTemplate &&
                            <span style={{ position: 'absolute', top: 0, right: 10 }}>
                                <i style={{ marginRight: 5, color: 'rgb(34,159,136)', fontSize: 20 }} onClick={() => { this.getInputRaspuns(`raspuns${ic.id}`, ic, ic) }} className="material-icons chestionare-list-intrebari-icons">edit</i>
                                <i onClick={() => { this.deleteSubintrebare(ic) }} style={{ marginRight: 0, color: 'rgb(244,20,41)', fontSize: 20 }} className="material-icons chestionare-list-intrebari-icons">clear</i>
                            </span>
                        }
                    </span>
                )
            })
        }
        else {


            return varianteRaspuns.map((r, idx) => {
                return (

                    <span style={{ marginLeft: 5, display: 'block', position: 'relative', width: '100%', marginBottom: 10, }} key={'raspuns' + idx} > {new Utils().alfabet[idx]}) 
                        <Flash animationLength='0.5s' Active={r.active} id={`animateraspuns${r.id}`}>
                            {/* <span style={{display:this.state.hideText ? 'inline-block' : 'none', wordBreak:'break-all', width:'90%'}} >{r.label}</span>    */}

                            {this.props.isTemplate ?
                                <span style={{
                                    color: 'rgba(0, 0, 0, 0.87)',
                                    fontSize: 15,
                                }}>
                                    {r.label}
                                </span>

                                :

                                <input
                                    disabled={this.props.isTemplate || this.props.intrebare.tip === 'grupaj'}
                                    style={{
                                        width: '62%',
                                        textAlign: 'left',
                                        backgroundColor: 'transparent',
                                        color: 'rgba(0, 0, 0, 0.87)',
                                        textOverflow: 'ellipsis',
                                        lineHeight: 1,

                                        margin: 0,
                                        fontSize: 15,
                                        fontFamily: 'inherit',
                                        verticalAlign: 'text-top',

                                        padding: 0
                                    }}
                                    id={`raspuns${r.id}`}
                                    onFocus={(e) => {
                                        var val = e.target.value;
                                        e.target.value = '';
                                        e.target.value = val;
                                    }}
                                    className='chestionare-task-time-input'
                                    type='text'
                                    value={r.label || " "}
                                    onChange={(ev) => { this.props.changeRaspuns(ev, r) }}
                                    onBlur={() => { this.updateRaspuns(r) }} />
                            }



                            {!this.props.isTemplate &&
                                <span style={{ position: 'absolute', top: 0, right: 10 }}>
                                    <i style={{ marginRight: 5, color: 'rgb(34,159,136)', fontSize: 20 }} onClick={() => { this.getInputRaspuns(`raspuns${r.id}`, r) }} className="material-icons chestionare-list-intrebari-icons">edit</i>
                                    <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, color: 'rgb(244,20,41)', fontSize: 20 }} className="material-icons chestionare-list-intrebari-icons">clear</i>
                                </span>
                            }
                        </Flash>
                    </span>



                )
            })
        }


    }

    getInfoIntrebare = () => {
        this.props.onClick(this.props.intrebare)

    }

    deleteIntrebare = () => {
        this.props.delete(this.props.intrebare)
    }

    mutaSus = () => {
        this.props.mutaSus(this.props.idx)
    }
    mutaJos = () => {
        this.props.mutaJos(this.props.idx)
    }

    updateIntrebare = async () => {
        // console.log('intrebareToUpdate :', this.props.intrebare);

        let ws = new WsC();

        let updateIntrebare = await ws.update('chestionare_intrebari', { intrebare: this.props.intrebare.intrebare }, { id: this.props.intrebare.id })

        if (updateIntrebare.Succes) {
            this.setState({ hideText: true })
            //   console.log('succesUpdate :', updateIntrebare);
        }
    }

    moveToList = () => {
        this.setState({ fade: true }, () => {
            this.props.moveToList(this.props.intrebare)
        })

        setTimeout(() => {
            this.setState({ fade: false })
        }, 1000)
    }


    deleteIntrebare = () => {

        this.setState({ zoomActive: true }, () => {
            setTimeout(() => {
                this.props.deleteIntrebare(this.props.intrebare)
            }, 400)
        })

    }

    getChestionar = () => {
        //  console.log('getChestionar :');
    }

    updateSubintrebare = async () => {

        let objSubintrebare = {
            intrebare: this.state.objIntrebareChild.intrebare,
            tip: this.state.objIntrebareChild.tip,
            motivatie_label: this.state.objIntrebareChild.motivatie_label
        }

        let ws = new WsC()

        let subUpdate = await ws.update('chestionare_intrebari', objSubintrebare, { id: this.state.objIntrebareChild.id })

        if (subUpdate.Succes) {
            this.props.getRaspunsuri()
        }

    }

    changeSubintrebareTitle = (ev) => {
        let subIntrebare = { ...this.state.objIntrebareChild }

        subIntrebare.intrebare = ev.target.value

        this.setState({ objIntrebareChild: subIntrebare })
    }

    motivatieChange = (ev) => {
        let subIntrebare = { ...this.state.objIntrebareChild }

        subIntrebare.motivatie_label = ev.target.value

        this.setState({ objIntrebareChild: subIntrebare })
    }


    hoverIntrebare = (id) =>{
        console.log('hover :>> ', );

        let button = document.getElementById(id)

        button.style.display = 'block'
    }

    notHoverIntrebare = (id) =>{
        console.log('notHover :>> ', );

        let button = document.getElementById(id)

        button.style.display = 'none'
    }


    render() {
        return (
            <div>
                {this.props.isTemplate !== true &&
                    <div >
                        <DialogSubIntrebare
                            open={this.state.isOpenSubintrebare}
                            dialogClose={() => { this.setState({ isOpenSubintrebare: false }) }}
                            getRaspunsuri={this.props.getRaspunsuri}
                            getChestionar={this.getChestionar}
                            objIntrebareInfo={this.state.objIntrebareChild}
                            updateIntrebare={this.updateSubintrebare}
                            objIntrebareParent={this.props.intrebare}
                            numeChange={this.changeSubintrebareTitle}
                            motivatieChange={this.motivatieChange}
                            title={this.props.intrebare.intrebare}
                            ref={this.subIntrebare}
                        />
                        <HeadShake Active={this.props.intrebare.id === this.props.intrebareToAnimate ? true : false} >
                            <Zoom Active={this.state.zoomActive}>
                                <div style={{ textAlign: 'right', marginTop: 10, marginBottom: 10 }}>
                                    <Button className='chestionare-main-button' onClick={() => { this.props.openEdit(this.props.intrebare) }} >
                                        Editeaza Suplimentar
                                    </Button>
                                </div>

                                <ListItem button >


                                    <ListItemText primary={<h3 style={{ paddingLeft: 0, position: 'relative' }} className='chestionare-list-text'>
                                        <span style={{ verticalAlign: 'top' }}> {this.props.idx + 1 + '.'}</span>
                                        <span style={{ display: this.state.hideText ? 'inline-block' : 'none', wordBreak: 'break-word', width: '80%' }} >{this.props.intrebare.intrebare}</span>
                                        <textarea
                                            disabled={this.props.isTemplate}
                                            style={{
                                                width: '80%',
                                                textAlign: 'left',
                                                backgroundColor: 'transparent',
                                                color: 'rgba(108,108,108	)',
                                                fontWeight: 'bold',
                                                border: '1px solid rgb(180, 178, 178)',
                                                lineHeight: 1,
                                                display: this.state.hideText ? 'none' : 'inline',
                                                margin: 0,
                                                fontSize: 15,
                                                fontFamily: 'inherit',
                                                verticalAlign: 'text-top',

                                                padding: 0
                                            }}
                                            ref={this.textInput}
                                            onFocus={(e) => {
                                                var val = e.target.value;
                                                e.target.value = '';
                                                e.target.value = val;
                                            }}
                                            className='chestionare-task-time-input'
                                            type='text'
                                            value={this.props.intrebare.intrebare || " "}
                                            onChange={(ev) => { this.props.changeIntrebare(ev, this.props.intrebare) }}
                                            onBlur={this.updateIntrebare} >

                                        </textarea>



                                    </h3>}

                                        secondary={<span style={{ paddingLeft: this.props.idx === 0 ? 30 : 0, margin: 10 }} className='chestionare-list-subtext'>
                                            {this.props.intrebare.tip === 'text' ? 'Text Liber' : this.filterRaspunsuri()}

                                            {!this.props.intrebare.tip.includes('img') && this.props.intrebare.tip.indexOf('text') === -1 &&
                                                <span style={{ marginLeft: 10, display: 'block', position: 'relative', width: '100%', marginBottom: 10 }}>


                                                    <textarea
                                                        disabled={this.props.isTemplate}
                                                        style={{
                                                            width: '80%',
                                                            textAlign: 'left',
                                                            backgroundColor: 'transparent',
                                                            color: 'rgba(0, 0, 0, 0.87)',

                                                            lineHeight: 1,

                                                            margin: 0,
                                                            fontSize: 15,
                                                            fontFamily: 'inherit',
                                                            verticalAlign: 'text-top',

                                                            padding: 0
                                                        }}

                                                        onFocus={(e) => {
                                                            var val = e.target.value;
                                                            e.target.value = '';
                                                            e.target.value = val;
                                                        }}
                                                        className='chestionare-task-time-input'
                                                        type='text'
                                                        value={this.state.raspunsNou || " "}
                                                        onChange={(ev) => { this.setState({ raspunsNou: ev.target.value }) }}
                                                    />
                                                    <span style={{ position: 'absolute', top: 0, right: 36 }}>


                                                        <i style={{ marginRight: 10, color: 'rgb(34,159,136)', fontSize: 20 }} onClick={this.insertRaspuns} className="material-icons chestionare-list-intrebari-icons">add</i>

                                                        {/* <i onClick={()=>{this.props.deleteIntrebare(this.props.intrebare)}} style={{marginRight:0, color:'rgb(244,20,41)', fontSize:20}} className="material-icons chestionare-list-intrebari-icons">clear</i> */}
                                                    </span>
                                                </span>
                                            }


                                        </span>}
                                    />


                                </ListItem>
                            </Zoom>
                        </HeadShake>
                        <Divider className="crm-divider" />

                    </div>
                }
                {this.props.isTemplate === true &&
                    <div draggable onDragStart={() => { this.props.dragStart(this.props.intrebare) }}  >

                        <Slide direction="right" in={!this.state.fade} mountOnEnter unmountOnExit>
                            <div style={{position:'relative'}} onMouseOver={()=>{this.hoverIntrebare(`save-button${this.props.intrebare.id}`)}} onMouseLeave={()=>{this.notHoverIntrebare(`save-button${this.props.intrebare.id}`)}}  id={`intrebare${this.props.intrebare.id}`}>
                                <ListItem button >
                                    {/* {
                                    !this.props.left &&
                                    <i className="material-icons" onClick={this.moveToList} style={{ fontSize: 34, color: '#16ac48', display: this.props.preview ? 'none' : 'inline-block', cursor: 'pointer' }}>keyboard_arrow_left</i>
                                } */}
                                    <ListItemText primary={<h3 className='chestionare-list-text'>

                                        {this.props.idx + 1 + '.'}    {this.props.intrebare.intrebare}
                                    </h3>}

                                        secondary={<span className='chestionare-list-subtext'>
                                            {this.props.intrebare.tip === 'text' ? 'Text Liber' : this.filterRaspunsuri()}
                                        </span>}
                                    />


                                    {/* {
                                    this.props.left &&
                                    <i className="material-icons" onClick={this.moveToList} style={{ fontSize: 34, color: '#16ac48', display: this.props.preview ? 'none' : 'inline-block', cursor: 'pointer' }}>keyboard_arrow_right</i>
                                } */}



                                </ListItem>
                                <Fab id={`save-button${this.props.intrebare.id}`} 
                                style={{ display:'none', backgroundColor: '#80cd5a', width: 40, height: 40, position:'absolute', top:'20%', right:10 }} onClick={this.moveToList} >
                                        <CheckCircle className=' iconSvg' style={{ marginRight: 0, width: 20, height: 20, color: 'white' }} />
                                    </Fab>
                                {/* <Button style={{ width: '90%', marginBottom:20 }} variant="contained" onClick={this.moveToList} className='creeaza-button'>
                                <i className='material-icons'>add_circle_outline</i>  Adauga
                                    </Button> */}
                            </div>
                        </Slide>
                        <Divider className="crm-divider" />
                    </div>
                }
            </div>
        )
    }
}


ListaIntrebariChestionareTemplate.propType = {
    listaIntrebari: PropTypes.array,
    pozitieNoua: PropTypes.func,
    isTemplate: PropTypes.bool,
    openIntrebare: PropTypes.func,
    goToIntrebare: PropTypes.func,
    dragStart: PropTypes.func,
    moveToList: PropTypes.func,
    deleteIntrebare: PropTypes.func,

};


LiListaIntrebari.propType = {
    raspunsuri: PropTypes.array,
    intrebare: PropTypes.object,
    idx: PropTypes.number,
    isTemplate: PropTypes.bool,
    dragStart: PropTypes.func,

}





